import {Component, OnInit} from '@angular/core';
import {SubjectTest} from '../../models/subject-test';
import {ActivatedRoute, Router} from '@angular/router';
import {SubjectTestService} from '../../services/subject-test.service';
import {Languages, LanguagesMap} from '../../const/common';
import {Student} from '../../models/student';

@Component({
  selector: 'app-subject-test-list',
  templateUrl: './subject-test-list.component.html',
  styleUrls: ['./subject-test-list.component.scss']
})
export class SubjectTestListComponent implements OnInit {

  tests: SubjectTest[] = [];
  languagesMap = LanguagesMap;
  selectedTest: SubjectTest = new SubjectTest();
  student: Student;
  attempts: string;
  confirmStart = false;
  currentSubject: string;
  lesson: string;
  constructor(private route: ActivatedRoute,
              private router: Router,
              private subjectTestService: SubjectTestService) {
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.currentSubject = params.get('lesson');
      this.attempts = params.get('attempts');
      this.subjectTestService.getSubjectTestByLesson(this.currentSubject).then(res => {
        this.tests = res;
      });
    });
  }

  startTest(): void {
      this.router.navigateByUrl(`subject-test/${this.selectedTest._id}`);
  }

  confirmStartTest(test: SubjectTest): void {
    this.confirmStart = true;
    this.selectedTest = test;
  }
}
